@if (showActionRequired() && isTaskOwner()) {
    <div
        class="relative bg-[#FFD200] rounded-tr-xl rounded-tl-xl p-2 cursor-pointer"
        [routerLink]="['/escalation/pending-requests']"
    >
        <h6 class="m-0 text-lg">{{ 'action-required.title' | translate }}</h6>
    </div>
}
